var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "main" }, [
      _c("h3", [_vm._v("Основная информация")]),
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _vm.loading ? _c("loading") : _vm._e(),
          !_vm.loading
            ? _c(
                "div",
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        {
                          attrs: {
                            span: 12,
                            xs: 24,
                            sm: 24,
                            md: 12,
                            lg: 12,
                            xl: 12,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "el-card box-card is-always-shadow mb-4",
                            },
                            [
                              _c("div", { staticClass: "el-card__header" }, [
                                _c("div", { staticClass: "clearfix" }, [
                                  _c("span", [_vm._v("Статистика")]),
                                ]),
                              ]),
                              _c("div", { staticClass: "el-card__body" }, [
                                _c("span", [
                                  _vm._v("Автомобили: "),
                                  _c(
                                    "strong",
                                    { staticClass: "text-primary" },
                                    [_vm._v(_vm._s(_vm.cars_items))]
                                  ),
                                  _vm._v(" / "),
                                  _c(
                                    "strong",
                                    { staticClass: "text-primary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatSize(_vm.cars_filesize)
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("br"),
                                _c("span", [
                                  _vm._v("Тюнинг/Экстерьер: "),
                                  _c(
                                    "strong",
                                    { staticClass: "text-primary" },
                                    [_vm._v(_vm._s(_vm.tuning_items))]
                                  ),
                                  _vm._v(" / "),
                                  _c(
                                    "strong",
                                    { staticClass: "text-primary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatSize(_vm.tuning_filesize)
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("br"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }